import { View } from "react-native";
import React from "react";
import Dialog, { DialogProps } from "components/Dialog";
import { TicketDetails } from "features/types";
import { Text } from "@ui-kitten/components";
import i18n from "plugins/localization";

interface ReleaseTicketDialogProps extends DialogProps {
  tickets: TicketDetails[];
}

const ReleaseTicketDialog: React.FC<ReleaseTicketDialogProps> = ({
  visible,
  setVisible,
  tickets,
  ...rest
}) => {
  return (
    <Dialog visible={visible} setVisible={setVisible} {...rest}>
      <Text category="h6" style={{ marginBottom: 15 }}>
        {tickets.length === 1
          ? i18n.t("screens.EventDetail.releaseReservation", { count: 1 })
          : // set count to 2 to trigger the plural version
            i18n.t("screens.EventDetail.releaseReservation", { count: 2 })}
      </Text>
      <Text>
        {tickets.length === 1
          ? i18n.t("screens.EventDetail.releaseReservationPrompt", { count: 1 })
          : // set count to 2 to trigger the plural version
            i18n.t("screens.EventDetail.releaseReservationPrompt", {
              count: 2,
            })}
      </Text>
    </Dialog>
  );
};

export default ReleaseTicketDialog;
